import {
    Dropdown,
    Label,
    Option,
    Skeleton,
    SkeletonItem,
} from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { customerUpdatesState } from '../../../../../store/features/customerUpdates/customerUpdatesSlice';
import { useSubformStyles } from './useSubformStyles';
import { useId } from 'react';

export interface UnableToNotifySubformProps {
    onSelect: (reason: string | undefined) => void;
}

export const UnableToNotifySubform: React.FC<UnableToNotifySubformProps> = ({
    onSelect,
}) => {
    const { t } = useTranslation();
    const { unableToNotifyReasons } = useSelector(customerUpdatesState);
    const styles = useSubformStyles();

    const reasons = unableToNotifyReasons.data;
    const noReasons = !unableToNotifyReasons.data.length;

    const dropdownId = useId();

    return unableToNotifyReasons.loadStatus !== 'loading' ? (
        <>
            <div className={styles.field}>
                <Label htmlFor={dropdownId} required>
                    {t('CustomerDialog_SelectUnableToNotifyReason')}
                </Label>
                <Dropdown
                    id={dropdownId}
                    onOptionSelect={(_, data) => onSelect(data.optionText)}
                    disabled={noReasons}
                    value={noReasons ? t('CustomerDialog_NA') : undefined}
                >
                    {reasons.map((x) => (
                        <Option key={x.id}>{x.displayName}</Option>
                    ))}
                </Dropdown>
            </div>
        </>
    ) : (
        <Skeleton>
            <SkeletonItem />
        </Skeleton>
    );
};
